// Fade out the preloader as soon as the DOM is ready — NOT window.load, which
// waits for every image/font/iframe and on slow mobile keeps the overlay up for
// many seconds (it was the page's biggest LCP render-delay).
const hidePreloader = () => {
  const preloader = document.getElementById('preloader');
  if (!preloader) return;
  preloader.classList.add('preloader-fade-out');
  setTimeout(() => { preloader.style.display = 'none'; }, 1000);
};

if (document.readyState !== 'loading') {
  hidePreloader(); // script is deferred, DOM is usually ready already
} else {
  document.addEventListener('DOMContentLoaded', hidePreloader);
}
